module.exports = __webpack_public_path__ + "d1b87bd703afc13aeea399f50a740e77.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/products/mug-black-blank.png
// module id = 846
// module chunks = 0